module.exports = __webpack_public_path__ + "static/img/avator.3c38b15c.png";